<div>
    <p class="text-uppercase mt-5">{{oneColArea_params.preTitle}}</p>
    <h1>{{oneColArea_params.title}}</h1>
    <p>{{oneColArea_params.mainText}}</p>
    <li routerLink="{{oneColArea_params.mainButtonLink}}">
        <a routerLink="{{oneColArea_params.mainButtonLink}}" class="btn-more">{{oneColArea_params.mainButtonText}}<div class="icon uparrow"></div></a>
    </li>
</div>
